module.exports = __webpack_public_path__ + "img/restaurant-6.6e48d7f8.jpg";